import { Entity } from './entity';
export interface Event {
    id: string;
    type: string;
    user: any;
    date: string;
    group: string;
}

export enum EventTrackReference {
    REQUEST = 'request',
    VERSION = 'version',
    MULTIPLE = 'multiple'
  }

export interface EventTrack extends Entity {
    // key: string; // MAybe remove afteer usin id for the event identifier
    title: string;
    reference: EventTrackReference; // project || artwork
}

// TODO event properties depending on the kind of the event should be perfect
export interface LogbookEvent extends Event {
    title: string;
}